import client from '@/api/client';

import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export const COMMISSIONS_UPDATE_CLEAR = 'proposal_attempts/commissions_update/CLEAR';
export const COMMISSIONS_UPDATE_START = 'proposal_attempts/commissions_update/START';
export const COMMISSIONS_UPDATE_SUCCESS = 'proposal_attempts/commissions_update/SUCCESS';
export const COMMISSIONS_UPDATE_FAILURE = 'proposal_attempts/commissions_update/FAILURE';

const multiple = '/proposals/:proposal_id/proposal_attempts';
const single = '/proposals/:proposal_id/proposal_attempts/:id/:status?';

const proposalAttempts = crudlModuleGenerator('proposalAttempts', {
  customEndpoints: {
    create: multiple,
    read: single,
    update: single,
    delete: single,
    list: multiple,
  },
});

function identify(response, id) {
  // eslint-disable-next-line no-underscore-dangle, no-param-reassign
  response._INTERNAL = {
    id,
  };
}

export default {
  ...proposalAttempts,
  state: {
    ...proposalAttempts.state,

    commissionsUpdate: {
      loading: false,
      result: {},
      error: null,
    },
  },

  actions: {
    ...proposalAttempts.actions,

    commissionsUpdate({ commit }, { proposal_id: proposalID, id, payload }) {
      commit(COMMISSIONS_UPDATE_START);
      return new Promise((resolve, reject) => {
        client.put(`/proposals/${proposalID}/proposal_attempts/${id}/bank_commissions`, payload)
          .then((response) => {
            identify(response, id);

            commit(COMMISSIONS_UPDATE_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(COMMISSIONS_UPDATE_FAILURE, error);
            reject(error);
          });
      });
    },

    commissionsUpdateClear({ commit }) {
      return new Promise((resolve) => {
        commit(COMMISSIONS_UPDATE_CLEAR);
        resolve();
      });
    },
  },

  mutations: {
    ...proposalAttempts.mutations,

    [COMMISSIONS_UPDATE_CLEAR](state) {
      state.commissionsUpdate.error = null;
      state.commissionsUpdate.result = {};
      state.commissionsUpdate.loading = false;
    },
    [COMMISSIONS_UPDATE_START](state) {
      state.commissionsUpdate.error = null;
      state.commissionsUpdate.result = {};
      state.commissionsUpdate.loading = true;
    },
    [COMMISSIONS_UPDATE_SUCCESS](state, response) {
      // eslint-disable-next-line no-underscore-dangle
      const id = response._INTERNAL && response._INTERNAL.id;

      if (id) {
        state.list.items[id].bank_commissions = response.data.bank_commissions;
      }

      state.commissionsUpdate.error = null;
      state.commissionsUpdate.result = response.data;
      state.commissionsUpdate.loading = false;
    },
    [COMMISSIONS_UPDATE_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.commissionsUpdate.error = details;
      state.commissionsUpdate.result = {};
      state.commissionsUpdate.loading = false;
    },
  },
};
